import mixpanel from 'mixpanel-browser';
import {Locale} from '../../RootProvider/LocaleContext';
import {ObjectOfAny, User} from '../../types';
import {flattenObject} from '../../utils/objects';
import removeEmptyValuesFromObject from '../../utils/removeEmptyValuesFromObject';

export enum MixpanelTrackEvent {
  liteQuoteFormSubmitSuccess = 'lite_quote_form_submit_success',
  quoteFormStepFour = 'quote_form_step_four',
  quoteFormStepOne = 'quote_form_step_one',
  quoteFormStepThree = 'quote_form_step_three',
  quoteFormStepTwo = 'quote_form_step_two',
}

export enum GTMTrackEvent {
  phoenixLeadCreated = 'phoenixLeadCreated',
  phoenixSubmit = 'phoenixSubmit',
}

export const initMixpanel = (): void => {
  if (!process.env.MIXPANEL_API_TOKEN) {
    return;
  }
  const config = {
    api_host: 'https://api-eu.mixpanel.com',
    // loaded: (mp: Mixpanel) => { // leaving this here as it's useful for debugging
    //   const distinctId = mp.get_distinct_id();
    // },
  };

  mixpanel.init(process.env.MIXPANEL_API_TOKEN, config);
};

export enum EventType {
  GTM = 'gtm',
  MIXPANEL = 'mixpanel',
}

interface RequiredTrackingEventValues extends ObjectOfAny {
  locale: Locale;
}

interface Event {
  name: MixpanelTrackEvent | GTMTrackEvent;
  values?: RequiredTrackingEventValues;
}

interface TrackEvent extends Event {
  eventType: EventType;
}

// Google tag manager
const dispatchGAEvent = ({name}: Event) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({event: name.toString()});
};

const dispatchMixpanelEvent = ({name, values}: Event) => {
  if (!process.env.MIXPANEL_API_TOKEN) {
    return;
  }
  const cleanedValues = values ? removeEmptyValuesFromObject(values) : {};
  const {password, ...other} = flattenObject(cleanedValues); // always remove password
  mixpanel.track(name.toString(), {...other});
};

export const dispatchMixpanelSuperEvent = (user: Partial<User>): void => {
  if (!process.env.MIXPANEL_API_TOKEN) {
    return;
  }
  mixpanel.register({
    email: user.email,
    env: process.env.STAGE,
    first_name: user.first_name,
    last_name: user.last_name,
  });
};

export const trackEvent = ({name, eventType, values}: TrackEvent): void => {
  if (eventType === EventType.GTM) {
    dispatchGAEvent({name});
  }
  if (eventType === EventType.MIXPANEL) {
    dispatchMixpanelEvent({name, values});
  }
};
export default {trackEvent};
